<div class="progress-indicator__max-progress" #maxProgressIndicator>
  <div class="progress-indicator__total-progress" #currentProgressIndicator></div>
</div>
<div class="progress-indicator__text">{{ progress }}% Complete</div>
